import $ from 'jquery';

export default function () {

    if (sessionStorage.getItem('status') === 'submitted') {

        $('#contact-form-response-id').show();
        $('.js-response-cta').addClass('is-active');
        setTimeout(function() {
            sessionStorage.removeItem('status');
        }, 1500);
    }

    let $form = $('#contact-form-wrapper-id').find('form');
    if ($form && $form.length) {

        $form.on('submit', function () {

            sessionStorage.setItem('status','submitted');

        });

    }

}
